import { gql } from '@apollo/client'

export const REMOVE_TEST_SESSION_MEMBER = gql`
  mutation RemoveTestSessionMember($inputData: RemoveTestSessionMemberInput!) {
    removeTestSessionMember(inputData: $inputData)
  }
`
